import {Injectable} from '@angular/core';
import {HttpService} from '@app/core/services/http.service';
import {AuthService} from '@app/core/services/auth.service';
import {BaseService} from '@app/core/services/base.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {ShiftTemplate} from '@app/core/models/shift-template.model';
import {Moment} from 'moment';
import {ShiftDraft} from '@app/core/models/ShiftDraft.model';
import {RDate} from '@app/core/models/rDate.model';

@Injectable()
export class ShiftTemplateService extends BaseService {
	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		public store: Store<IAppState>,
	) {
		super(authService, interService, httpService, store);
	}

	public postWeek(copyingWeek: any[], startDate: Moment, shiftDraft: ShiftDraft | null | undefined): Observable<any> {
		const offsets = this.calculateUtcOffsets(startDate);

		const data = {
			template_string: JSON.stringify(copyingWeek),
			start_date: startDate.format('YYYY-MM-DD'),
			app_utc_offsets: offsets,
		};
		if (shiftDraft) {
			data['shift_draft_id'] = shiftDraft.id;
		}

		return this.httpService.postJson('shifts/template', data);
	}

	public getTemplates(departmentId: number): Observable<any[]> {
		return this.httpService.getJson('shiftTemplates', {
			department_id: departmentId,
		});
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	public create(shiftTemplate: ShiftTemplate, departmentId: number): Observable<{ template: ShiftTemplate }> {
		return this.httpService.postJson<{ template: ShiftTemplate }>('shiftTemplates', {
			...shiftTemplate,
			department_id: departmentId,
		});
	}

	public insert(shiftTemplate: ShiftTemplate, startDate: Moment, shiftDraft: ShiftDraft | null | undefined): Observable<any> {
		const offsets = this.calculateUtcOffsets(startDate);

		const data = {
			template_id: shiftTemplate.id,
			start_date: startDate.format('YYYY-MM-DD'),
			app_utc_offsets: offsets,
		};
		if (shiftDraft) {
			data['shift_draft_id'] = shiftDraft.id;
		}

		return this.httpService.postJson('shifts/template', data);
	}

	public delete(shiftTemplateId: number): Observable<any> {
		return this.httpService.deleteJson<void>('shiftTemplates/' + shiftTemplateId);
	}

	private calculateUtcOffsets(startDate: Moment): number[] {
		const offsets = [];

		for (let i = 0; i < 14; i++) {
			const rDate = new RDate(this.tenantTZ, this.interService).deserialize(startDate.clone().add(i, 'days'), undefined, undefined, true);
			offsets.push(rDate.localDate.utcOffset());
		}

		return offsets;
	}
}
